import {ChangeDetectionStrategy, Component, Inject, output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatIcon} from "@angular/material/icon";
import {MatOption} from "@angular/material/select";
import {FormControl, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatIconButton} from "@angular/material/button";
import {MarkType, TipTapEditor, TipTapEditor_DI_TOKEN} from "../../tiptap/TipTapEditor";
import {MatInput} from "@angular/material/input";
import {MatAutocomplete, MatAutocompleteTrigger} from "@angular/material/autocomplete";
import {erNil, standard} from "felles-ng2/støttefunksjoner/nilsjekk";
import {erTall} from "felles-ng2/støttefunksjoner/tall";
import {filter} from "rxjs";

const debug = initDebugger('RiktekstRedigeringFontStørrelseVelgerKomponentKomponent');

/**
 * Skjema for å endre font-størrelse
 */
@Component({
    selector: 'riktekst-redigering-font-stoerrelse-velger',
    templateUrl: 'font-størrelse-velger.html',
    styleUrl: 'font-størrelse-velger.scss',
    imports: [
        MatIcon,
        MatOption,
        ReactiveFormsModule,
        MatIconButton,
        MatInput,
        MatAutocompleteTrigger,
        MatAutocomplete
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiktekstRedigeringFontStørrelseVelgerKomponentKomponent {

    aktivert = output<boolean>();

    private readonly standardVerdi = 10;
    readonly stoerrelser = this.tilgjengeligeStørrelser();
    readonly kontroll = new FormControl<number>(this.standardVerdi, {nonNullable: true, validators: [Validators.pattern(/\d+/), Validators.min(4), Validators.max(100)]});

    constructor(@Inject(TipTapEditor_DI_TOKEN) protected editor: TipTapEditor) {
        this.kontroll.valueChanges
          .pipe(
            filter(() => this.kontroll.valid),
            takeUntilDestroyed()
          )
          .subscribe(størrelse => this.setStørrelse(størrelse));

        this.editor.vedTilstandEndret(() => this.lesStørrelse())
          .subscribe(størrelse => this.kontroll.setValue(størrelse, {emitEvent: false})); //emitEvent:false slik at ikke kontroll.valueChanges trigges
    }

    vedMenyLukket() {
        this.aktivert.emit(false);
    }

    vedMenyAapnet() {
        this.aktivert.emit(true);
    }

    leggTil(mengde: number) {
        const nyVerdi = erTall(this.kontroll.value) ? this.kontroll.value + mengde : this.standardVerdi; //om feltet skulle være blankt returnerer vi standard størrelse
        this.kontroll.setValue(nyVerdi);
    }

    vedFokusMistet() {
        if (this.kontroll.invalid) this.kontroll.setValue(this.standardVerdi);
    }

    //private hjelpemetoder

    private lesStørrelse(): number {
        return standard(this.editor.editor.getAttributes(MarkType.TextStyle).fontstørrelse, this.standardVerdi);
    }

    private setStørrelse(størrelse: number) {
        if (erNil(størrelse) || størrelse === this.standardVerdi)
            this.editor.editor.chain().focus().fjernFontstoerrelse().run();
        else
            this.editor.editor.chain().focus().setFontstoerrelse(størrelse).run();
    }

    private tilgjengeligeStørrelser() {
        return [
            {stoerrelse: 6, navn: '6pt'},
            {stoerrelse: 8, navn: '8pt'},
            {stoerrelse: 9, navn: '9pt'},
            {stoerrelse: 10, navn: '10pt (standard)'},
            {stoerrelse: 11, navn: '11pt'},
            {stoerrelse: 12, navn: '12pt'},
            {stoerrelse: 14, navn: '14pt'},
            {stoerrelse: 16, navn: '16pt'},
            {stoerrelse: 18, navn: '18pt'},
            {stoerrelse: 20, navn: '20pt'},
            {stoerrelse: 22, navn: '22pt'},
            {stoerrelse: 24, navn: '24pt'},
            {stoerrelse: 26, navn: '26pt'},
            {stoerrelse: 28, navn: '28pt'},
            {stoerrelse: 36, navn: '36pt'},
            {stoerrelse: 48, navn: '48pt'},
            {stoerrelse: 72, navn: '72pt'}
        ];
    }

}
